<template>
  <v-container fluid>
    <div>
      <div>{{user}}</div>
      <div>{{cup}}</div>
      <div>{{customer}}</div>
      <loyalty-card />
      <footer-card />
    </div>
  </v-container>
</template>

<script>
import LoyaltyCard from "../components/LoyaltyCard.vue";
import FooterCard from "../components/Footer.vue";

import { mapState } from "vuex";

export default {
  metaInfo() {
    return {
      meta: [
        {
          name: "theme-color",
          content: this.color
        }
      ]
    };
  },
  data() {
    return {};
  },
  methods: {},
  computed: {
    ...mapState(["user", "cup", "customer"]),
    color() {
      if (this.lightMode) {
        return "#62A0F0";
      } else {
        return "#021F23";
      }
    },
    lightMode: {
      get() {
        return this.$store.state.lightMode;
      },
      set(val) {
        return this.$store.commit("setLightMode", val);
      }
    }
  },
  created() {
    if (this.$route.params) {
      if (this.$route.params.id) {
        this.$store.dispatch("getCup", this.$route.params.id);
      }
    }
  },
  components: {
    LoyaltyCard,
    FooterCard
  }
};
</script>

<style>
/* * {
  border: solid 1px red;
} */
</style>
